module.exports = "<!-- ko component:{ name: 'department-edit', params: {\n    department: department\n}} --> <!-- /ko --> ";